var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EXPLORE_BANK_DETAILS, EXPLORE_CLIENT_SEARCH, EXPLORE_DELETED_DRAFT_DOCS, EXPLORE_DIRTY_PRICE, EXPLORE_DP_DETAILS, EXPLORE_DRAFT_ORDER, EXPLORE_DRAFT_ORDER_DETAILS, EXPLORE_EMP_PARTNER_DETAILS, EXPLORE_PREVIEW_DRAFT_DOCS, EXPLORE_RECENT_CLIENT_SEARCH, EXPLORE_RECENT_CLIENT_SEARCH_SAVE, EXPLORE_SAVED_DRAFT_DOCS, EXPLORE_VALIDATE_DIRTY_PRICE, EXPLORE_VALIDATE_QUANTITY, RESET_VALUE, SAVE_DRAFT_ORDER_DECLARATIONS, SAVE_ORDER, SET_PAYMENT_SUCCESS, SET_TRANSACTIONJOURNEY_DATA, SET_TRANSACTIONJOURNEY_DETAILS, SET_TRANSACTIONJOURNEY_FEE, SET_TRANSACTIONJOURNEY_MODE, SET_TRANSACTIONJOURNEY_UPLOAD_DECLARTION, UPDATE_BANK_CODE_DETAILS, UPDATE_CLIENT_DETAILS, UPDATE_CXO_IS_SELETED_CLIENT, UPDATE_CXO_SELETED_CLIENT, UPDATE_DRAFT_ORDERS_REQUEST_PAYLOAD_ID, UPDATE_ISIN_CLIENT_DETAILS, UPDATE_ISIN_FIXING_DETAILS, UPDATE_SET_UP_FEE, UPDATE_TRANSACTION_ID, UPDATE_TRANSACTION_VISIBLE, UPDATE_VALIDATE_SETUPFEE, } from "../actions/TransactionJourneyActions";
var initialState = {
    transactionJourney: {
        dpDetails: "",
        quantity: null,
        dirtyPrice: null,
    },
    paymentMode: {
        type: "",
        bankName: {
            label: "",
            value: "",
        },
        rtgsNo: "",
    },
    purchaseFee: {
        setUpFees: "",
        sbName: "",
        passout: "",
    },
    uploadDeclaration: [],
    paymentSuccess: false,
    transactionDetails: null,
    transactionVisible: false,
    dpDetails: null,
    draftOrdersRequestPayload: null,
    recentClientSearch: null,
    recentClientSearchSave: null,
    clientDetails: null,
    selectedClientDetails: null,
    bankDetails: null,
    empPartnerDetails: null,
    transactionId: null,
    bankCodeDetails: null,
    saveOrderData: null,
    isValidSetUpFee: true,
    isinClientDetails: null,
    fixingDetails: null,
    validateSetUpFees: null,
    seletedClientOwner: null,
    isChangeClientOwner: false,
};
var transactionJourney = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_TRANSACTIONJOURNEY_DATA:
            return __assign(__assign({}, state), { transactionJourney: action.payload.transactionJourney });
        case EXPLORE_EMP_PARTNER_DETAILS:
            return __assign(__assign({}, state), { empPartnerDetails: action.payload.empPartnerDetails });
        case EXPLORE_DIRTY_PRICE:
            return __assign(__assign({}, state), { dirtyPriceDetails: action.payload.dirtyPriceDetails });
        case UPDATE_CXO_IS_SELETED_CLIENT:
            return __assign(__assign({}, state), { isChangeClientOwner: action.payload.isChangeClientOwner });
        case UPDATE_CXO_SELETED_CLIENT:
            return __assign(__assign({}, state), { seletedClientOwner: action.payload.seletedClientOwner });
        case EXPLORE_VALIDATE_QUANTITY:
            return __assign(__assign({}, state), { validateQuantity: action.payload.validateQuantity });
        case UPDATE_VALIDATE_SETUPFEE:
            return __assign(__assign({}, state), { validateSetUpFees: action.payload.validateSetUpFees });
        case EXPLORE_VALIDATE_DIRTY_PRICE:
            return __assign(__assign({}, state), { validateDirtyPrice: action.payload.validateDirtyPrice });
        case SET_TRANSACTIONJOURNEY_DETAILS:
            return __assign(__assign({}, state), { transactionDetails: action.payload.transactionDetails });
        case SET_TRANSACTIONJOURNEY_MODE:
            return __assign(__assign({}, state), { paymentMode: action.payload.paymentMode });
        case SET_TRANSACTIONJOURNEY_FEE:
            return __assign(__assign({}, state), { purchaseFee: action.payload.purchaseFee });
        case SET_TRANSACTIONJOURNEY_UPLOAD_DECLARTION:
            return __assign(__assign({}, state), { uploadDeclaration: action.payload.uploadDeclaration });
        case SET_PAYMENT_SUCCESS:
            return __assign(__assign({}, state), { paymentSuccess: action.payload.paymentSuccess });
        case UPDATE_TRANSACTION_VISIBLE:
            return __assign(__assign({}, state), { transactionVisible: action.payload.transactionVisible });
        case UPDATE_ISIN_CLIENT_DETAILS:
            return __assign(__assign({}, state), { isinClientDetails: action.payload.isinClientDetails });
        case EXPLORE_DRAFT_ORDER:
            return __assign(__assign({}, state), { draftOrder: action.payload.draftOrder });
        case EXPLORE_DRAFT_ORDER_DETAILS:
            return __assign(__assign({}, state), { draftOrderDetails: action.payload.draftOrderDetails });
        case EXPLORE_PREVIEW_DRAFT_DOCS:
            return __assign(__assign({}, state), { previewDraftDocs: action.payload.previewDraftDocs });
        case EXPLORE_DELETED_DRAFT_DOCS:
            return __assign(__assign({}, state), { deletedDraftDocs: action.payload.deletedDraftDocs });
        case EXPLORE_SAVED_DRAFT_DOCS:
            return __assign(__assign({}, state), { savedDraftDocs: action.payload.savedDraftDocs });
        case EXPLORE_DP_DETAILS:
            return __assign(__assign({}, state), { dpDetails: action.payload.dpDetails });
        case UPDATE_DRAFT_ORDERS_REQUEST_PAYLOAD_ID:
            return __assign(__assign({}, state), { draftOrdersRequestPayload: action.payload.draftOrdersRequestPayload });
        case EXPLORE_RECENT_CLIENT_SEARCH_SAVE:
            return __assign(__assign({}, state), { recentClientSearchSave: action.payload.recentClientSearchSave });
        case EXPLORE_RECENT_CLIENT_SEARCH:
            return __assign(__assign({}, state), { recentClientSearch: action.payload.recentClientSearch });
        case EXPLORE_CLIENT_SEARCH:
            return __assign(__assign({}, state), { clientDetails: action.payload.clientDetails });
        case SAVE_ORDER:
            return __assign(__assign({}, state), { saveOrderData: action.payload.saveOrderData });
        case UPDATE_SET_UP_FEE:
            return __assign(__assign({}, state), { isValidSetUpFee: action.payload.isValidSetUpFee });
        case UPDATE_CLIENT_DETAILS:
            return __assign(__assign({}, state), { selectedClientDetails: action.payload.selectedClientDetails });
        case EXPLORE_BANK_DETAILS:
            return __assign(__assign({}, state), { bankDetails: action.payload.bankDetails });
        case UPDATE_TRANSACTION_ID:
            return __assign(__assign({}, state), { transactionId: action.payload.transactionId });
        case UPDATE_ISIN_FIXING_DETAILS:
            return __assign(__assign({}, state), { fixingDetails: action.payload.fixingDetails });
        case SAVE_DRAFT_ORDER_DECLARATIONS:
            return __assign(__assign({}, state), { draftOrderDeclarations: action.payload.draftOrderDeclarations });
        case RESET_VALUE:
            return {
                transactionJourney: {
                    dpDetails: "",
                    quantity: "",
                    dirtyPrice: "",
                },
                paymentMode: {
                    type: "",
                    bankName: {
                        label: "",
                        value: "",
                    },
                    rtgsNo: "",
                    chequeNo: "",
                },
                purchaseFee: {
                    setUpFees: "",
                    sbName: "",
                    passout: "",
                },
                uploadDeclaration: [],
                paymentSuccess: false,
                transactionDetails: null,
                transactionId: null,
            };
        case UPDATE_BANK_CODE_DETAILS:
            return __assign(__assign({}, state), { bankCodeDetails: action.payload.bankCodeDetails });
        default:
            return state;
    }
};
export default transactionJourney;
